import controller from './by-favorites.controller';
import templateBase from './templates/by-favorites-base.view.html';
import templateAD from './templates/by-favorites-adaptative.html';

let ByFavoritesComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    if(__env.adaptative) {
      return templateAD;
    } else {
      return templateBase;
    }
}

export default ByFavoritesComponent



/** WEBPACK FOOTER **
 ** ./www/components/fast-purchase/by-favorites/by-favorites.component.js
 **/